module.exports = __webpack_public_path__ + "static/img/introduce.7e6a7995.png";